import digitalData from '~/common/services/data-layer-service';

export function dataLayerPushRYIForm(
  formName: string,
  model: string,
  user: Record<string, string>
) {
  digitalData.push({
    event: '_formNavigate',
    form: {
      name: formName,
      stage: 'submitted',
      details: {
        vehicleSelected: [
          {
            make: 'Subaru',
            model,
          },
        ],
      },
    },
    user,
  });
}
